export default function AutoenrollmentGroupNotificationsWarning() {
  return (
    <span>
      <strong>Notify settings will apply to future members enrolled in this group.</strong> If notifications are
      enabled, emails and messages will be sent to new members automatically. Settings can be changed at any time.
    </span>
  );
}
